import React from "react";
import { Modal } from "react-bootstrap";
import PerfectScrollbar from 'perfect-scrollbar';
import { wait, isMobile, isTablet, Event, __, hasClass } from 'utils/Helper';

const chatSideBarWidth = 330;

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chat: false
        }
    }

    render() {
        return (
            <>
                {this.props.children}
            </>
        );
    }
}

export default Layout;
